<breadcrumb [breadcrumbList]="breadcrumbList"></breadcrumb>
<div *ngIf="pageLoading" class="loader text-center">
	<img src="../assets/img/loading.gif" />
</div>
<div class="card" *ngIf="UserModuleAccess=='Full'">
	<div class="card-header bg-theme">
		{{pagetitle}}
	</div>
	<div class="card-body">
		<form class="form-horizontal" [formGroup]="moduleForm" (ngSubmit)="saveData()" #modform="ngForm">
			<div class="row mb-2">
				<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
					<div class="form-floating">
						<input class="form-control" [ngClass]="{'is-invalid':showError('scale_name')}" id="scale_name"
							formControlName="scale_name" placeholder="">
						<label for="scale_name">Scale Name*</label>
					</div>
					<p *ngIf="showError('scale_name')" class="text-danger">
						<span *ngIf="f.scale_name.errors?.required">
							Required
						</span>
						<span *ngIf="f.scale_name.errors?.incorrect">
							{{customError.scale_name}}
						</span>
					</p>
				</div>
				<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
					<div class="form-floating">
						<input class="form-control" [ngClass]="{'is-invalid':showError('acronym')}" id="acronym"
							formControlName="acronym" placeholder="">
						<label for="acronym">Acronym*</label>
					</div>
					<p *ngIf="showError('acronym')" class="text-danger">
						<span *ngIf="f.acronym.errors?.required">
							Required
						</span>
						<span *ngIf="f.acronym.errors?.incorrect">
							{{customError.acronym}}
						</span>
					</p>
				</div>
			</div>
			<div class="row mb-2">
				<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
					<div class="form-floating">
						<input class="form-control" [ngClass]="{'is-invalid':showError('description')}" id="description"
							formControlName="description" placeholder="">
						<label for="description">Description*</label>
					</div>
					<p *ngIf="showError('description')" class="text-danger">
						<span *ngIf="f.description.errors?.required">
							Required
						</span>
						<span *ngIf="f.description.errors?.incorrect">
							{{customError.description}}
						</span>
					</p>
				</div>
			</div>
			<div class="row mb-2">
				<div class="col text-center">
					<button type="submit" [disabled]="showLoader || !modform.dirty"
						class="btn btn-sm btn-outline-success">
						<span class="me-1">
							<fa-icon *ngIf="showLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
							<fa-icon *ngIf="!showLoader" [icon]="['fas', 'save']"></fa-icon>
						</span>
						<span>Save</span>
					</button>
					<a class="btn btn-sm btn-outline-dark ms-1" [routerLink]="['/app/scale-list']">Cancel</a>
				</div>
			</div>
		</form>
	</div>
</div>
<div *ngIf="UserModuleAccess!='Full'">
	<h3 class="text-center">You don't have access to this section.</h3>
</div>